import isMatch from "date-fns/isMatch";
import { isArray, isObject } from "lodash";

const DEFAULT_RETURN_VALUE = false;

/**
 * return true when all the date match the format
 * @param {*} dateArr
 * @returns
 */
export const validateAllDates = (dateArr = []) => {
  try {
    return dateArr.every((date) => isMatch(date, "yyyy-MM-dd"));
  } catch (error) {
    return DEFAULT_RETURN_VALUE;
  }
};

/**
 * return true when it's {}
 * @param {*} obj
 * @returns
 */
export const validateObject = (obj) => {
  try {
    if (isArray(obj)) return false;
    if (isObject(obj)) return true;
    return false;
  } catch (error) {
    return DEFAULT_RETURN_VALUE;
  }
};

export const validateInclude = ({ obj, word }) => {
  try {
    return obj.toUpperCase().includes(word.toUpperCase());
  } catch (error) {
    return DEFAULT_RETURN_VALUE;
  }
};

export const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
